import * as React from 'react'

import * as styles from './cardPreview.module.css'

interface IProps {
  children: React.ReactNode
  categoryName?: string
}

const CardPreview: React.SFC<IProps> = ({ categoryName, children }: IProps) => (
  <div className={styles.preview}>
    {children}
    {categoryName && <span className={styles.category}>{categoryName}</span>}
  </div>
)

export default CardPreview
